import { useEffect, useRef } from "react";

import { msUntilNextVenueDay, today } from "./forecastRange";

/*
 * Calls back when the venue's calendar day changes underneath an open panel.
 */
export default function useVenueDayRollover(timezone, onRollover) {
  // Held in a ref so a new callback each render does not reschedule the timer.
  const callback = useRef(onRollover);
  useEffect(() => {
    callback.current = onRollover;
  }, [onRollover]);

  useEffect(() => {
    let timer = null;

    const tick = () => {
      const previous = seen.current;
      const current = today(timezone);

      if (current !== previous) {
        seen.current = current;
        callback.current(current, previous);
      }

      schedule();
    };

    const schedule = () => {
      timer = setTimeout(tick, Math.max(1000, msUntilNextVenueDay(timezone)));
    };

    const seen = { current: today(timezone) };
    schedule();

    return () => clearTimeout(timer);
  }, [timezone]);
}
